import { render, staticRenderFns } from "./other-form.html?vue&type=template&id=5414e22b&scoped=true&external"
import script from "./other-form.js?vue&type=script&lang=js&external"
export * from "./other-form.js?vue&type=script&lang=js&external"
import style0 from "./other-form.scss?vue&type=style&index=0&id=5414e22b&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5414e22b",
  null
  
)

export default component.exports